import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, checking } = useAuth();
  const loc = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center text-njas-muted">
        <div className="animate-pulse text-sm">Checking session…</div>
      </div>
    );
  }
  if (!user || !user.id) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
